import { PackageListingHeader, PackageListingHeaderPrice } from '@pcln/horizon-package-components'
import React from 'react'

/**
 * Package listings title on the left, package price on the right.
 * Shared so PKG_FLY_RC_LISTINGS_PRICE_PLACEMENT can render it above the filters
 * without duplicating the layout.
 */
export function PackageListingHeaderRow(props) {
  return (
    <div className='flex flex-col gap-2 lg:flex-row lg:justify-between lg:gap-0 mx-2 mb-2 lg:mx-0'>
      <div className='lg:order-1'>
        <PackageListingHeader {...props} currentProduct='FLY' hidePrice />
      </div>
      <div className='lg:order-2 lg:flex lg:flex-col lg:items-end lg:gap-1'>
        <PackageListingHeaderPrice {...props} currentProduct='FLY' />
      </div>
    </div>
  )
}
